// src/utils/parsers/eyatirimciParser.js
import * as XLSX from 'xlsx';
import { standardizeStockData } from './fileUtils';

const formatNumber = (value) => {
  if (!value) return 0;
  
  // Excel'den gelen sayıyı string'e çevir
  const strValue = value.toString();
  
  // Sayıda virgül varsa (örn: 19,2815)
  if (strValue.includes(',')) {
    // Virgülü noktaya çevir ve float'a dönüştür
    return parseFloat(strValue.replace(',', '.'));
  }
  
  // Virgül yoksa normal sayı olarak dön
  return parseFloat(strValue);
};

export const parseEYatirimciXLS = async (file) => {
  try {
    const buffer = await file.arrayBuffer();
    console.log('Reading Excel file...');

    const options = {
      type: 'array',
      cellDates: false,
      cellNF: false,
      cellText: false,
      raw: true
    };

    const workbook = XLSX.read(buffer, options);
    console.log('Available sheets:', workbook.SheetNames);

    let stockData = [];
    let foundValidSheet = false;

    for (const sheetName of workbook.SheetNames) {
      console.log(`Checking sheet: ${sheetName}`);
      const worksheet = workbook.Sheets[sheetName];
      
      const jsonData = XLSX.utils.sheet_to_json(worksheet, {
        header: 1,
        raw: false,
        defval: ''
      });

      console.log('Sample row data:', jsonData.slice(0, 3));

      const headerRowIndex = jsonData.findIndex(row =>
        row.some(cell => {
          const cellStr = String(cell).toLowerCase();
          return cellStr.includes('menkul kıymet') || 
                 cellStr.includes('menkul kiymet') ||
                 cellStr.includes('hisse kodu') ||
                 cellStr.includes('sembol');
        })
      );

      if (headerRowIndex === -1) continue;

      console.log('Found header row at index:', headerRowIndex);
      const headers = jsonData[headerRowIndex].map(h => String(h).toLowerCase());
      console.log('Headers:', headers);

      const symbolIndex = headers.findIndex(h => 
        h.includes('menkul kıymet') || 
        h.includes('menkul kiymet') || 
        h.includes('hisse kodu') || 
        h.includes('sembol')
      );
      const priceIndex = headers.findIndex(h => 
        h.includes('fiyat') || 
        h.includes('kur')
      );
      const quantityIndex = headers.findIndex(h => 
        h.includes('adet') || 
        h.includes('miktar') || 
        h.includes('lot')
      );

      console.log('Column indexes:', { symbolIndex, priceIndex, quantityIndex });

      if (symbolIndex === -1 || priceIndex === -1 || quantityIndex === -1) {
        console.log('Required columns not found in this sheet');
        continue;
      }

      foundValidSheet = true;

      const stocks = jsonData.slice(headerRowIndex + 1)
        .filter(row => row[symbolIndex]) // Sembol olan satırları al
        .map(row => {
          // Ham değerleri logla
          console.log('Raw row values:', {
            symbol: row[symbolIndex],
            price: row[priceIndex],
            shares: row[quantityIndex]
          });

          const rawStock = {
            symbol: String(row[symbolIndex] || ''),
            shares: formatNumber(row[quantityIndex]),
            price: formatNumber(row[priceIndex]),
            total: 0, // Hesaplanacak
            cost: formatNumber(row[priceIndex]), // Fiyatı maliyet olarak kullan
            profitLoss: 0 // Hesaplanacak
          };

          console.log('Formatted stock data:', rawStock);
          return standardizeStockData(rawStock);
        })
        .filter(stock => stock.symbol && stock.shares > 0);

      stockData = stockData.concat(stocks);
    }

    if (!foundValidSheet) {
      throw new Error('Hisse senedi verisi içeren bir sayfa bulunamadı');
    }

    if (stockData.length === 0) {
      throw new Error('İşlenebilir hisse senedi verisi bulunamadı');
    }

    console.log('Final processed stocks:', stockData);
    return stockData;

  } catch (error) {
    console.error('Excel parse error:', error);
    throw new Error(`Excel dosyası işlenirken hata oluştu: ${error.message}`);
  }
};